import { IconButton, styled, Toolbar } from '@mui/material';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import HamburgetIcon from '../../../../../../assets/icons/hamburger.svg';
import LoadSvgIcon from '../../../../../component/LoadSvgIcon/LoadSvgIcon';
import { TopBarProps } from '.';
import RightItems from './components/RightItems';
import { CreateTaskButton } from '../CreateTaskButton';
import { WBBox } from '@admiin-com/ds-web';
import { useFirmId } from '../../../../../hooks/useClientWorkflow/useClientWorkflow';

export const TopBarMobile = (props: TopBarProps) => {
  const { firmId } = useFirmId();
  return (
    <AppBar position="fixed">
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <WBBox>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={props.onChange}
            edge="start"
          >
            <LoadSvgIcon component={HamburgetIcon} width={18} height={16} />
          </IconButton>
          {!firmId && <CreateTaskButton onClick={props.onCreateTask} />}
        </WBBox>
        <RightItems />
      </Toolbar>
    </AppBar>
  );
};

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme }) => ({
  // zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
  variants: [
    {
      props: ({ open }) => open,
      style: {
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));
